import React, { useState, useEffect } from 'react';
import { Box, Typography, Button, IconButton, Fade, Zoom, CircularProgress, Stack, Grid } from '@mui/material';
import EmojiButton from '../../../views/PupilDashboard/Login/Emoji/EmojiButton';
import SelectedEmoji from '../../../views/PupilDashboard/Login/Emoji/SelectedEmoji';
import participantsApi from '../../../services/api/participants/participantsApi';
import paths from '../../../routes/paths';
import BackspaceIcon from '@mui/icons-material/Backspace';
import { emojis } from '../../../utils/emojis';
import { iconSmiley } from '../../assets/images';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';

const EmojiLoginForm = ({ onBackClick }) => {
  const [code, setCode] = useState([null, null, null, null, null, null]);
  const [position, setPosition] = useState(0);
  const [loading, setLoading] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => { localStorage.removeItem('pupil'); }, []);

  const handleEmojiClick = value => {
    if (position >= 6) return;
    const newCode = [...code];
    newCode[position] = value;
    setCode(newCode);
    setPosition(position + 1);
  };
  const handleEmojiRemove = () => {
    if (position <= 0) return;
    const newCode = [...code];
    newCode[position - 1] = null;
    setCode(newCode);
    setPosition(position - 1);
  };
  const handleSubmit = () => {
    setLoading(true);
    setError(null);
    participantsApi.checkPasscode(code.join(''))
      .then(res => {
        if (res && res.studentId > 0) {
          setShowSuccess(true);
          localStorage.setItem('pupil', JSON.stringify(res));
          setTimeout(() => { window.location.href = paths.pupilSurveys; }, 1000);
        } else {
          setError('Invalid passcode. Please try again.');
          setCode([null, null, null, null, null, null]);
          setPosition(0);
        }
      })
      .catch(() => {
        setError('Error validating passcode');
        setCode([null, null, null, null, null, null]);
        setPosition(0);
      })
      .finally(() => setLoading(false));
  };

  return (
    <>
      <div className="formHeader">
        <div className="iconContainer">
          <img src={iconSmiley} alt="" />
        </div>
        <h2 className="formTitle">
          Login with Emoji
        </h2>       
      </div>

       {/* <div className="formDescription">
          Enter your emoji passcode to access your surveys
        </div> */}

      {error && (
        <Typography color="error" sx={{ mb: 2 }}>{error}</Typography>
      )}

      <Fade in={!showSuccess} timeout={300}>
        <div>
          {/* <div className={`${styles.selectedEmojiContainer} ${styles.emojiPasscode}`}> */}

          <Stack direction="row" alignItems="center" justifyContent="center" columnGap={2} my={3}>
            <div className="emojiPasscode">              
              {code.map((value, index) => (
                <div className="select-emoji">
                  <Zoom in={value !== null} key={index}>
                    <div>
                      <SelectedEmoji value={value} />
                    </div>
                  </Zoom>
                </div>
              ))
              }
            </div>

            <div>
              <IconButton onClick={handleEmojiRemove} color="primary" aria-label="remove last emoji" disabled={position === 0 || loading}><BackspaceIcon /></IconButton>
            </div>
          </Stack>

          <Typography variant="h6" align="center" gutterBottom>
            Please click the emojis that match the ones given to you by your teacher
          </Typography>

          {/* <Box className={`${styles.emojiGrid} ${loading ? styles.disabledGrid : ''}`}> */}
          <div className="emojiGrid">
            {emojis.map((emoji, index) => (
              <div key={index} className="emojiButtonWrapper">
                <EmojiButton icon={emoji.icon} value={emoji.value} handleClick={handleEmojiClick} disabled={loading || position >= 6} />
              </div>))
            }
          </div>

          <Grid container justifyContent="center">
            <Grid item lg={6} md={6} sm={11} xs={11} mt={2}>
              <Button
                variant="contained"
                onClick={handleSubmit}
                disabled={code.filter(x => x === null).length > 0 || loading}              
                className="formButton"
                disableElevation
                disableRipple
              >
                {loading ? 'Verifying...' : 'Start Survey'}
              </Button>

              {onBackClick && (
                <Button
                  fullWidth
                  variant="text"            
                  onClick={onBackClick}
                  disabled={loading}
                  startIcon={<KeyboardBackspaceIcon />} disableRipple
                  className="backButton"
                >
                  Back to Login Options
                </Button>
              )}
            </Grid>
          </Grid>
        </div>
      </Fade>
    </>
  );
};

export default EmojiLoginForm;
